export default {
  visitList: state => state.visitList,
  visitTypeList: state => state.visitTypeList,
  signInList: state => state.signInList,
  signInDetail: state => state.signInDetail,
  salesmanTableData: state => state.salesmanTableData,
  busiLineTableData: state => state.busiLineTableData,
  customTableData: state => state.customTableData,
  depaBusiLineTableData: state => state.depaBusiLineTableData,
  threeBusiLineTableData: state => state.threeBusiLineTableData,
  departmentTableData: state => state.departmentTableData,
  cusInsuranceTableData: state => state.cusInsuranceTableData,
  cusBankTableData: state => state.cusBankTableData,
  cusHealManagementTableData: state => state.cusHealManagementTableData,
  cusInternetTableData: state => state.cusInternetTableData,
  cusOprationTableData: state => state.cusOprationTableData,
  dep3OfBusPerformanceTableData: state => state.dep3OfBusPerformanceTableData,
  customerRevenueTableData: state => state.customerRevenueTableData,
  timingRecordList: state => state.timingRecordList,
  timingRecordTeams: state => state.timingRecordTeams,
  timingRecordDetail: state => state.timingRecordDetail,
  proOnlineTopData: state => state.proOnlineTopData,
  proOfflineTopData: state => state.proOfflineTopData,
  telCounselingTableData: state => state.telCounselingTableData,
  offlineServiceTableData: state => state.offlineServiceTableData,
  customSelectData: state => state.customSelectData,
  doctelConnectionList: state => state.doctelConnectionList,
  statisticsTeamList: state => state.statisticsTeamList,
};
